import React from 'react';

import {SquareGrid} from '@homeaway/landing-presentational';

import EdapViewTracker from '../../../components/common/edap-view-tracker/EdapViewTracker';

import {handleClick, ACTION_LOCATION} from '../events';
import {buildImageUrl, BASE_CLASS} from '../constants';

const DynamicDestinationRefinementsMobile = ({lbsId, heading, cards}) => {
    const items = cards.map((card) => ({
        href: card.serpUrl,
        label: card.heading,
        imageSrc: buildImageUrl(card.imageUrl),
        filterId: card.filterId,
    }));

    const mkClickHandler = (item, idx) =>
        handleClick({lbsId, position: idx, filterId: item.filterId});

    return (
        <div className={`${BASE_CLASS} container module`}>
            <h2>{heading}</h2>
            <SquareGrid items={items} onClick={mkClickHandler} />
            <EdapViewTracker eventData={{actionlocation: ACTION_LOCATION}} />
        </div>
    );
};

DynamicDestinationRefinementsMobile.displayName =
    'DynamicDestinationRefinementsMobile';

export default DynamicDestinationRefinementsMobile;
